jQuery(document).ready(function($) {
/*
	//Show/Hide mobile menu (slide down)
	$(function() {
		var $burger		=	$('#hamburger-button');
		var $navigation =	$('#menu--primary');
		var $overlay 	=	$('#overlay');

		$burger.add($overlay).click(function()  {
			$navigation.toggleClass('menu--is-visible');
			$burger.toggleClass('hamburger--is-open');
			$overlay.toggleClass('overlay--is-visible');
		});
	});

*/
	//Show/Hide mobile menu (push left/right)
	$(function() {
		var $sidebar = $('#js-sidebar-menu');
		var $burger = $('#js-hamburger-button');
		var $overlay = $('#js-overlay');

		$burger.add($overlay).click(function() {
			$('.push-sidebar').toggleClass('-is-open');
			$sidebar.toggleClass('-is-open');
			$overlay.toggleClass('overlay--is-visible');
			$burger.toggleClass('hamburger--is-open');
		});
	});


	//Init slick slider
	$('.carousel').slick({
		dots: false,
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		centerMode: true,
		variableWidth: true,
		focusOnSelect: false
	});


	//Load warning message if browser does not support flexbox
	if (!Modernizr.flexbox) {
		$('body').prepend('<div class="browser-not-supported">Lo sentimos, el navegador que utilizas está desactualizado y es posible que la página no se visualice correctamente. Actualízalo o accede desde desde algún navegador alternativo para disfrutar de una experiencia completa</div>');
	}


	//Remove :focus outline unless user is using the keyboard to navigate
	function handleFirstTab(e) {
		if (e.keyCode === 9) {
			document.body.classList.add('user-is-tabbing');
			window.removeEventListener('keydown', handleFirstTab);
			window.addEventListener('mousedown', handleMouseDownOnce);
		}
	}
	function handleMouseDownOnce() {
		document.body.classList.remove('user-is-tabbing');
		window.removeEventListener('mousedown', handleMouseDownOnce);
		window.addEventListener('keydown', handleFirstTab);
	}
	window.addEventListener('keydown', handleFirstTab);

	//Smooth scroll on anchor links
	$('a[href*="#"]:not([href="#"], [href*="#tab"])').click(function() { //[href*="#tab"] to avoid compatibility issues with woocommerce tabs
	  if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
	    var target = $(this.hash);
	    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
	    if (target.length) {
	      $('html, body').animate({
	        scrollTop: target.offset().top
	      }, 500);
	      return false;
	    }
	  }
	});


	//Float labels on focus on WPCF7 contact forms
	$(".contact-form__input").focus(function() {
		$(this).parent().siblings('label').addClass('-has-value');
	})
	//Blur input fields on unfocus + if has no value
	.blur(function() {
		var text_val = $(this).val();
		if(text_val === "") {
			$(this).parent().siblings('label').removeClass('-has-value');
		}
	});

	//Aplicamos las clases a la cabecera de las tablas de clasificación para mostrar flechas según el orden
	$(".js-sort-table").click(function () {

		//Añadimos a todas las cabeceras --none y les quitamos el orden que tengan (excepto a la que recibe el click)
		$('.js-sort-table').not(this).addClass('js-sort-table--none').removeClass('js-sort-table--asc js-sort-table--desc');

		//Si el elemento que recibe el click no está ordenado (--none)
		if($(this).hasClass('js-sort-table--none')) {
			//Aplicamos orden --desc, quitamos --none y salimos
			$(this).addClass('js-sort-table--desc').removeClass('js-sort-table--none');
			return;
		}
		//Si el elemento que recibe el click  está ordenado --desc
		if($(this).hasClass('js-sort-table--desc')) {
			//Aplicamos orden --asc, quitamos --desc y salimos
			$(this).addClass('js-sort-table--asc').removeClass('js-sort-table--desc');
			return;
		}
		//Si el elemento que recibe el click  está ordenado --asc
		if($(this).hasClass('js-sort-table--asc')) {
			//Aplicamos orden --desc, quitamos --asc y salimos
			$(this).addClass('js-sort-table--desc').removeClass('js-sort-table--asc');
			return;
		}
	});
});
